import { api } from './index.js';

export const postTileData = async (
	projectId,
	taskId,
	currentTileName,
	data
) => {
	const json = data; /*JSON.stringify(postData)*/

	try {
		const res = await api.post(
			`/training/annotations/${projectId}/${taskId}/${currentTileName}`,
			json
		);
		return res.data;
	} catch (err) {
		return err.response;
	}
};

export const initTraining = async ({ projectUuid, modelId }) => {
	if (!modelId) {
		throw new Error('initTraining requires modelId');
	}

	// The backend ignores the project segment (it overwrites it with "dummy"
	// server-side), so models detached from a project — e.g. convert2bfm /
	// finetune outputs with project_uuid: null — must still be trainable.
	const { data } = await api.get(`/training/train/${projectUuid || 'dummy'}/${modelId}`);

	return data;
};

export const getTrainingAnnotations = async (projectUuid, modelUuid) => {
	const { data } = await api.get(
		`/training/annotations/${projectUuid}/${modelUuid}`,
		{
			params: {
				feature_type: 'annotation_polygon',
				single_image_mode: true,
			},
		}
	);

	return data;
};
